import PageBackTitle from "../Component/PageBackTitle";
import React, { useState, useEffect, useRef, useContext } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import API_URL from "../Config";
import Select from "react-select";
import { FiUpload } from "react-icons/fi";
import { MdAttachFile, MdDeleteOutline } from "react-icons/md";
import { IoCloseOutline } from "react-icons/io5";
import "../TableColor.css";
import useClickOutside from "../useClickOutside";
import { ThemeContext } from "../ThemeContext";
import DatePicker from "react-datepicker";

function EditManualWorkPermit({ isSidebarExpanded }) {
  const navigate = useNavigate();
  const { id } = useParams(); // assume your route is /edit-manual-workpermit/:id
  const { theme } = useContext(ThemeContext);
  console.log("id", id);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [severity, setSeverity] = useState("success");
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const [date, setDate] = useState(null);
  const [permitNumber, setPermitNumber] = useState("");
  const [selectedPermitType, setSelectedPermitType] = useState(null);
  const [description, setDescription] = useState("");

  const [selectedFiles, setSelectedFiles] = useState([]);
  const [existingFiles, setExistingFiles] = useState([]); // if you have stored files
  const [isPopupOpen, setIsPopupOpen] = useState(false);

  const [errors, setErrors] = useState({});

  const fileInputRef = useRef(null);
  const containerRef = useRef(null);
  const buttonRef = useRef(null);

  useClickOutside([containerRef, buttonRef, fileInputRef], () => {
    setIsPopupOpen(false);
  });

  const today = new Date();

  const permitTypeOptions = [
    { value: "Cold Work Permit", label: "Cold Work Permit" },
    { value: "Hot Work Permit", label: "Hot Work Permit" },
    {
      value: "Confined Space Entry Permit",
      label: "Confined Space Entry Permit",
    },
  ];

  // ✅ Fetch existing permit on mount
  useEffect(() => {
    const fetchPermit = async () => {
      try {
        const authKey = localStorage.getItem("authKey");
        const response = await axios.get(
          `${API_URL}/api/manual_work_permit/${id}`,
          {
            headers: {
              Authorization: authKey,
            },
          }
        );

        if (response.status === 200) {
          const data = response.data;
          console.log("response.data.asasaassa", data);

          setDate(new Date(data.date));
          setPermitNumber(data.permit_number);
          setSelectedPermitType(
            permitTypeOptions.find((opt) => opt.value === data.permit_type) ||
              null
          );
          setDescription(data.description || "");
          if (Array.isArray(data.attachments) && data.attachments.length > 0) {
            setExistingFiles(data.attachments);
          }
          console.log(
            "data?.ManualWorkPermits?.attachments",
            data?.attachments
          );
        }
      } catch (error) {
        console.error("Failed to fetch permit:", error);
        setSeverity("error");
        showSnackbar("Failed to fetch permit details.");
      }
    };

    fetchPermit();
  }, [id]);

  const handleDateChange = (selectedDate) => {
    setDate(selectedDate);
    setErrors((prev) => ({ ...prev, date: "" }));
  };

  const handlePermitNumberChange = (e) => {
    setPermitNumber(e.target.value);
    setErrors((prev) => ({ ...prev, permitNumber: "" }));
  };

  const handleDescriptionChange = (e) => {
    setDescription(e.target.value);
  };

  const handlePermitTypeChange = (selectedOption) => {
    setSelectedPermitType(selectedOption);
    setErrors((prev) => ({ ...prev, permitType: "" }));
  };

  const handleUploadButtonClick = () => {
    fileInputRef.current.click();
    setErrors((prev) => ({ ...prev, attachments: "" }));
  };

  const handleFileInputChange = (files) => {
    const fileArray = Array.from(files).slice(0, 1); // Only 1 file
    setSelectedFiles(fileArray);
    setExistingFiles([]); // clear old
    setErrors((prev) => ({ ...prev, attachments: "" }));
  };

  const handleDeleteFile = (index) => {
    setSelectedFiles([]); // only one file, so clear all
    setIsPopupOpen(false);
  };

  const handleIconClick = () => {
    setIsPopupOpen((prev) => !prev);
  };

  const handleCancelClick = () => {
    navigate("/manual-workpermit");
  };

  const handleSaveClick = async () => {
    let validationErrors = {};

    if (!date) validationErrors.date = "Date is required.";
    if (!permitNumber.trim())
      validationErrors.permitNumber = "Permit number is required.";
    if (!selectedPermitType)
      validationErrors.permitType = "Permit type is required.";

    // If there is no existing OR new file, error
    if (selectedFiles.length === 0 && existingFiles.length === 0) {
      validationErrors.attachments = "At least one attachment is required.";
    }

    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    try {
      setIsLoading(true);
      const authKey = localStorage.getItem("authKey");

      const formData = new FormData();
      const formattedDate = new Date(date).toISOString().split("T")[0];

      formData.append("date", formattedDate);
      formData.append("permit_type", selectedPermitType.value);
      formData.append("permit_number", permitNumber);
      formData.append("description", description);

      // Only append new files if there are any.
      if (selectedFiles.length > 0) {
        selectedFiles.forEach((file) => {
          formData.append("attachments", file);
        });
      }

      // PATCH or PUT depending on API
      const response = await axios.put(
        `${API_URL}/api/manual_work_permit/${id}`,
        formData,
        {
          headers: {
            Authorization: authKey,
            "Content-Type": "multipart/form-data",
          },
        }
      );

      if (response.status >= 200 && response.status < 300) {
        setSeverity("success");
        showSnackbar("Manual Work Permit updated successfully.");
        setTimeout(() => navigate("/manual-workpermit"), 1000);
      }
    } catch (error) {
      console.error("Error updating permit:", error);
      setSeverity("error");
      showSnackbar("Failed to update Manual Work Permit.");
    } finally {
      setIsLoading(false);
    }
  };

  const showSnackbar = (message) => {
    setSnackbarMessage(message);
    setSnackbarOpen(true);
  };

  const handleSnackbarClose = (event, reason) => {
    if (reason === "clickaway") return;
    setSnackbarOpen(false);
  };

  const handleCloseAttachment = () => {
    setIsPopupOpen(false);
  };

  const handleDeleteExistingFile = (id) => {
    setExistingFiles((prev) => prev.filter((file) => file.id !== id));
  };

  return (
    <>
      <div
        className={`data-form-content-container page-content ${
          isSidebarExpanded ? "expanded" : "collapsed"
        }`}
      >
        <div className="data-form-content" ref={containerRef}>
          <div className="data-form-header">
            <div className="data-form-header-content">
              <PageBackTitle className="data-form-heading-content-left-side">Edit Manual Work Permit</PageBackTitle>
            </div>
          </div>

          <div className="header-separator"></div>

          <div className="data-form-body">
            <div className="action-purchase-header">
              <div className="form-group">
                <label htmlFor="date">
                  Date<span className="text-danger">*</span>
                </label>
                <div className="input-group">
                  <DatePicker
                    selected={date}
                    onChange={handleDateChange}
                    placeholderText="Select date"
                    dateFormat="dd/MM/yyyy"
                    isClearable
                    showYearDropdown
                    showMonthDropdown
                    dropdownMode="select"
                    maxDate={today}
                    className={`${
                      theme === "dark" ? "dark-theme-datepicker" : ""
                    } half-width-input`}
                  />
                </div>
                {errors.date && (
                  <div className="error-message">{errors.date}</div>
                )}
              </div>

              <div className="form-group">
                <label htmlFor="permitNumber">
                  Permit No<span className="text-danger">*</span>
                </label>
                <div className="input-group">
                  <input
                    type="text"
                    name="permitNumber"
                    value={permitNumber}
                    onChange={handlePermitNumberChange}
                    placeholder="Enter permit number"
                  />
                </div>
                {errors.permitNumber && (
                  <span className="error-message">{errors.permitNumber}</span>
                )}
              </div>

              <div className="form-group-select">
                <label htmlFor="permitType">
                  Permit Type<span className="text-danger">*</span>
                </label>
                <Select
                  options={permitTypeOptions}
                  placeholder="Select permit type"
                  isSearchable
                  onChange={handlePermitTypeChange}
                  value={selectedPermitType}
                />
                {errors.permitType && (
                  <span className="error-message">{errors.permitType}</span>
                )}
              </div>

              <div className="form-group">
                <label htmlFor="description">Description</label>
                <div className="input-group">
                  <textarea
                    name="description"
                    value={description}
                    onChange={handleDescriptionChange}
                    placeholder="Enter description"
                    className="textarea-manual-work-permit-edit"
                    rows={4}
                    cols={10}
                  />
                </div>
              </div>

              <div className="form-group-attachments">
                <label htmlFor="attachments">
                  Attachments <span className="text-danger">*</span>
                </label>

                {/* Upload Button */}
                <button
                  type="button"
                  className="challan-btn"
                  onClick={handleUploadButtonClick}
                >
                  <FiUpload /> Upload File
                </button>

                {/* Hidden File Input */}
                <input
                  type="file"
                  ref={fileInputRef}
                  onChange={(e) => handleFileInputChange(e.target.files)}
                  style={{ display: "none" }}
                />

                {/* File Count Badge - shows either new or old */}
                {(selectedFiles.length > 0 || existingFiles.length > 0) && (
                  <span
                    className="inquiry-file-btn"
                    onClick={handleIconClick}
                    ref={buttonRef}
                  >
                    <MdAttachFile className="inquiry-file-icon" />{" "}
                    {selectedFiles.length > 0
                      ? selectedFiles.length
                      : existingFiles.length}
                  </span>
                )}

                {/* Attachment Popup */}
                {isPopupOpen && (
                  <div className="attach-popup-inward" ref={containerRef}>
                    <div className="attach-popup-contant">
                      <div className="attachment-header">
                        <div className="attachment-header-content">
                          Attachments
                        </div>
                        <button
                          className="fiile-close-btn"
                          onClick={handleCloseAttachment}
                        >
                          <IoCloseOutline className="file-close-icon" />
                        </button>
                      </div>

                      {/* NEW FILE PREVIEW */}
                      {selectedFiles.length > 0 && (
                        <div className="attach-scrroll-body">
                          {selectedFiles.map((file, index) => (
                            <div
                              className="attach-popup-contant-body"
                              key={index}
                            >
                              <div className="attach-file-container">
                                <div className="attach-file-show">
                                  <div className="">{file.name}</div>
                                  <div className="text-attachment-file">
                                    File Size: {(file.size / 1024).toFixed(2)}{" "}
                                    KB
                                  </div>
                                </div>
                                <div
                                  className="file-delete-btn"
                                  onClick={() => handleDeleteFile(index)}
                                >
                                  <MdDeleteOutline className="file-delete-icon" />
                                </div>
                              </div>
                            </div>
                          ))}
                        </div>
                      )}

                      {/* EXISTING FILE PREVIEW */}
                      {selectedFiles.length === 0 &&
                        existingFiles.length > 0 && (
                          <div className="attach-scrroll-body">
                            {existingFiles.map((file) => (
                              <div
                                className="attach-popup-contant-body"
                                key={file.id}
                              >
                                <div className="attach-file-container">
                                  <div className="attach-file-show">
                                    <a
                                      href={`${API_URL}/${file.file_path}`}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                      className=""
                                    >
                                      {file.filename}
                                    </a>
                                    <div className="text-attachment-file">
                                      File Size:{" "}
                                      {(file.file_size / 1024).toFixed(2)} KB
                                    </div>
                                  </div>
                                  <div
                                    className="file-delete-btn"
                                    onClick={() =>
                                      handleDeleteExistingFile(file.id)
                                    }
                                  >
                                    <MdDeleteOutline className="file-delete-icon" />
                                  </div>
                                </div>
                              </div>
                            ))}
                          </div>
                        )}
                    </div>
                  </div>
                )}
              </div>
            </div>

            <div className="footer">
              <div className="button-group">
                <button
                  className="data-form-save-button"
                  onClick={handleSaveClick}
                  disabled={isLoading}
                >
                  {isLoading ? "Saving..." : "Update"}
                </button>
                <button
                  className="data-form-cancel-button"
                  onClick={handleCancelClick}
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Snackbar
        open={snackbarOpen}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        style={{ top: "75px", marginLeft: "20px" }}
      >
        <MuiAlert onClose={handleSnackbarClose} severity={severity}>
          {snackbarMessage}
        </MuiAlert>
      </Snackbar>
    </>
  );
}

export default EditManualWorkPermit;
